import React from "react";

import InvoiceImage from "../../../assets/media/invoice.png"
import "./index.css";

const AddCommercialUserDialog = ({ goBrandAdmins }) => (
  <div
    className="modal fade add-commercial-user-dialog"
    id="add_commercial_user"
    tabIndex="-1"
    role="dialog"
    aria-labelledby="modal-default-fadein"
    aria-hidden="true"
  >
    <div className="modal-dialog" role="document">
      <div className="modal-content add-commercial-user-content">
        <div className="modal-body pb-1 add-commercial-user-dialog-body">
          <img src={InvoiceImage} width="70" alt="icon" />
          <p>
            Please add a commercial controller, who will control and manage your
            plan agreements.
          </p>
          <button
            type="button"
            className="btn btn-yellow"
            onClick={goBrandAdmins}
            data-dismiss="modal"
          >
            Add a controller
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default AddCommercialUserDialog;



// WEBPACK FOOTER //
// ./src/screens/UserPlatform/AddCommercialUserDialog/index.js